exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".detailsDisplayArea[data-v-31c02071] {\n  width: 100%;\n  min-height: 0;\n  overflow: hidden;\n}\n.detailsDisplayArea .arrayStructureContainer .textStyle[data-v-31c02071] {\n  font-size: 14px;\n}\n.detailsDisplayArea .arrayStructureContainer .imageStyle[data-v-31c02071] {\n  width: 100%;\n}\n.detailsDisplayArea .arrayStructureContainer .videoStyle[data-v-31c02071] {\n  width: 355.8px;\n  height: 200px;\n  background: #000;\n}\n", ""]);

// exports
